<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2">
          Ubah Config DP
        </v-card-title>
        <v-card-text>
          <v-form class="pt-5 pb-0" v-if="form.config_duedate.length > 0">
            <v-text-field
              v-for="(item, index) in form.config_duedate"
              :key="index"
              dense
              outlined
              :label="index > 0 ? 'Jatuh Tempo Seterunya' : 'Jatuh Tempo setelah Booking Fee'"
              prepend-inner-icon="mdi-calendar-month"
              :color="style.primary"
              v-model="item.duedate">
            </v-text-field>
          </v-form>
          <p class="text-center mt-12" v-if="form.config_duedate.length < 1">
            Anda belum membuat <b>Perusahaan</b> !!!
          </p>
          <p class="text-center" v-if="form.config_duedate.length < 1">
            Buat sekarang ? 
            <router-link to="/profile/company">
              Klik disini
            </router-link>
          </p>
          <v-alert 
            class="mx-10 mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-container class="py-0"> -->
      <v-row>
        <v-col cols="12" class="py-0">
          <v-card flat min-height="800">
            <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0':''">
              <v-row>
                <v-col cols="8" class="py-0">
                  <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                    :color="style.primary"
                    elevation="3"
                    class="text-capitalize white--text"
                    @click="reset()">
                    <v-icon small class="mr-1">mdi-pencil-minus-outline</v-icon>
                    Config DP
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"/>
            <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'px-0 py-0':'py-0'" style="min-height: 650px;">
              <v-skeleton-loader
                :loading="process.run"
                transition="scale-transition"
                :tile="false"
                type="table-tbody">
                <v-simple-table>
                  <template v-slot:default>
                    <thead v-if="!process.run && list.length > 0">
                      <tr>
                        <th class="text-left pl-0">Jatuh Tempo (/Hari)</th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(item, index) in list" 
                        :key="index">
                        <td class="text-second text-capitalize pl-0">
                          {{ item.duedate }}
                        </td>
                        <td class="text-right">
                          Hari
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-skeleton-loader>
              
              <div class="d-flex text-center text--secondary my-16 py-16" style="min-height: 550px;" v-if="!process.run && list.length < 1">
                <v-img 
                  class="my-16 py-16"
                  contain
                  width="200"
                  height="200"
                  :src="require('@/assets/404/404.svg')">
                </v-img>
              </div>
              <v-divider/>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    <!-- </v-container> -->
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        selected: {
          pagination: 0
        },
        dialog: {
          form: false,
          delete: false
        },
        filter: {
          title: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        form: {
          config_duedate: []
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        await get(`auth/company/config-duedate/detail`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false

            if (Object.keys(res.data).length > 0) {
              this.list = res.data.config_duedate_data
              
              this.form.config_duedate = []
              for(let i in this.list) {
                this.form.config_duedate.push({
                  step: this.list[i].step,
                  duedate: this.list[i].duedate,
                })
              }
            }
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false

        this.process.form = false

        this.error.message = ''
      },
      addConfig() {
        this.form.config_duedate.push({

        })
      },
      async save() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/config-duedate/create`, {
          data: {
            config_duedate: JSON.stringify(this.form.config_duedate)
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>